import DateFormat from '@/shared/utils/date-format';

export default class BillableItems {
  contractId: string;

  contractVersionId: string;

  contractNumber: string;

  itemNumber: number;

  customerName: string;

  beneficiaryName: string;

  competence: string;

  billingStartCompetence: string;

  description: string;

  processing: number;

  constructor(obj: any) {
    this.contractId = obj.contractId || '';
    this.contractNumber = obj.contractNumber || '';
    this.contractVersionId = obj.contractVersionId || '';
    this.customerName = obj.customerName || '';
    this.beneficiaryName = obj.beneficiaryName || '';
    this.competence = obj.competence || '';
    this.billingStartCompetence = obj.billingStartCompetence || '';
    this.itemNumber = obj.itemNumber || '';
    this.description = obj.description || '';
    this.processing = obj.processing || 0;
  }

  static of(obj: any): BillableItems {
    return new BillableItems(obj);
  }

  static ofList(obj: any[]): BillableItems[] {
    return obj.map(this.of)
  }

  get formattedCompetence(): string {
    return this.competence ? DateFormat.fullMonthAndYear(this.competence) : '';
  }

  get formattedBillingStartCompetence(): string {
    return this.billingStartCompetence ? DateFormat.fullMonthAndYear(this.billingStartCompetence) : '';
  }
}
